import { useState, useEffect } from "react";
import { ReactSession } from "react-client-session";
import {
  Link,
  useNavigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import axios from "axios";
import {
  Box,
  Flex,
  Select,
  Stack,
  Text,
  Button,
  Heading,
  Image,
  useColorModeValue,
  HStack,
  Link as ChakraLink,
  Container,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Tabs,
  TabPanel,
  TabList,
  Tab,
  TabPanels,
  Badge,
  Tooltip,
  Switch,
  FormControl,
  FormLabel
} from "@chakra-ui/react";
import { PopupButton } from "react-calendly";
import { BeatLoader } from "react-spinners";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";

import { FaPaperPlane, FaHammer, FaPlane, FaFly } from "react-icons/fa";
import { PiPottedPlantFill } from "react-icons/pi";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoRocketSharp } from "react-icons/io5";
import { MdInfoOutline } from "react-icons/md";
import { FiChevronsDown } from "react-icons/fi";
import { IoMdArrowDropright } from "react-icons/io";
import { PhoneIcon, WarningIcon } from "@chakra-ui/icons";

import { formatCreditUsage } from "../../utils/CreditFormat";
import { linksConfig } from "../../utils/CommonLinks";
import {
  featureList,
  FREE_DETAILS,
  BUILD_DETAILS,
  GROW_DETAILS,
  ACCELERATE_DETAILS,
} from "../LandingPage/LandingPageComponents/PricingStatic";
import CombinedHeading from "../common/CombinedHeading";
import { PlanIds } from "../../utils/Config";

const UNLIMITED_PLAN_PRICES = {
  build: {
    monthly: "$199",
    quaterly: { total: "$537", perMonth: "$179", productTotal: "$597" },
    semiAnually: { total: "$955", perMonth: "$160", productTotal: "$1,194" },
  },
  grow: {
    monthly: "$349",
    quaterly: { total: "$943", perMonth: "$315", productTotal: "$1,047" },
    semiAnually: { total: "$1676", perMonth: "$280", productTotal: "$2,094" },
  },
  accelerate: {
    monthly: "$649",
    quaterly: { total: "$1753", perMonth: "$584", productTotal: "$1,947" },
    semiAnually: { total: "$3116", perMonth: "$520", productTotal: "$3,894" },
  },
};

const LEGACY_PLAN_PRICES = {
  hack: {
    monthly: "$49",
    quaterly: { total: "$133", perMonth: "$45", productTotal: "$147" },
    semiAnually: { total: "$236", perMonth: "$39" , productTotal: "$294" },
  },
  launch: {
    monthly: "$199",
    quaterly: { total: "$537", perMonth: "$179", productTotal: "$597" },
    semiAnually: { total: "$955", perMonth: "$160", productTotal: "$1,194" },
  },
  scale: {
    monthly: "$499",
    quaterly: { total: "$1348", perMonth: "$449", productTotal: "$1,497" },
    semiAnually: { total: "$2395", perMonth: "$400", productTotal: "$3,894" },
  },
};

const PlanWeight = {
  HACK: 1,
  HACKQ: 2,
  HACKS: 3,
  LAUNCH: 4,
  LAUNCHQ: 5,
  LAUNCHS: 6,
  BUILD: 7,
  BUILDQ: 8,
  BUILDS: 9,
  GROW: 10,
  GROWQ: 11,
  GROWS: 12,
  SCALE: 13,
  SCALEQ: 14,
  SCALES: 15,
  ACCELERATE: 16,
  ACCELERATEQ: 17,
  ACCELERATES: 18
};

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];



const PricingPage = (props) => {
  const navigate = useNavigate();
  const [queryParameters] = useSearchParams();
  const { pathname, hash, key } = useLocation();
  const [offerData, setOfferData] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [billingCycle, setBillingCycle] = useState(1);

  const [showUpgradeCard, setShowUpgradeCard] = useState(false);
  const [showDowngradeCard, setShowDowngradeCard] = useState(false);
  const [updateCardType, setUpdateCardType] = useState("");
  const [updatePlanType, setUpdatePlanType] = useState("");
  const [updatePlanId, setUpdatePlanId] = useState("");
  const [updateStatus, setUpdateStatus] = useState("NO_ACTION");
  const [updateStatusMessage, setUpdateStatusMessage] = useState("");
  const [prorateValue, setProrateValue] = useState("--");
  const [prorateCurrency, setProrateCurrency] = useState("$");
  const [prorateLoading, setProrateLoading] = useState(false);
  const [currentSubscriptionEndDate, setCurrentSubscriptionEndDate] =
    useState("");

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash !== "") {
      //window.scrollTo(0, 0);
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element && id === "nft_offers") {
          //element.scrollIntoView({block: "center"});
          const clickElem = document.getElementById("offer_button");
          clickElem.click();
        }
      }, 1000);
    }
  }, [pathname, hash, key]);

  // const [pointerToggle,setPointerToggle] = useState(false);

  useEffect(() => {
    props.setApplicable(false);
  }, []);

  const [errOcc, setErrOcc] = useState(false);
  const [data, setData] = useState(null);
  const [freePlanSpecs, setFreePlanSpecs] = useState({
    name: "FREE",
    credits: 500000,
    amount: {
      usd: 0,
      inr: 0,
    },
    rateLimitPerSecond: 1,
    isHardStopActivatedOnPlan: true,
  });
  const [hackPlanSpecs, setHackPlanSpecs] = useState({
    name: "HACK",
    credits: 10000000,
    amount: {
      usd: 49,
      inr: 4089,
    },
    rateLimitPerSecond: 10,
    isHardStopActivatedOnPlan: true,
  });
  const [launchPlanSpecs, setLaunchPlanSpecs] = useState({
    name: "LAUNCH",
    credits: 100000000,
    amount: {
      usd: 199,
      inr: 16599,
    },
    rateLimitPerSecond: 30,
    isHardStopActivatedOnPlan: false,
    perCreditChargeAfterExceedingUsage: {
      usd: 0.00033,
      inr: 0.0016,
    },
  });
  const [scalePlanSpecs, setScalePlanSpecs] = useState({
    name: "SCALE",
    credits: 500000000,
    amount: {
      usd: 275,
      inr: 22320,
    },
    rateLimitPerSecond: 100,
    isHardStopActivatedOnPlan: false,
    perCreditChargeAfterExceedingUsage: {
      usd: 0.000165,
      inr: 0.0008,
    },
  });

  const selectPlanAndPay = (planName, plan) => {
    props.setPlan(plan);
    props.setPlanName(planName);
    props.setShowCard(true);
    try {
      window?.datafast("dash_pricing_pay_but");
    } catch (error) {
      console.log("some error");
    }
  };

  const setProrateChargeForToday = async (planId) => {
    const token = ReactSession.get("xTkn") ?? "";
    // const isFree = ReactSession.get("ifr") ?? "unknown";
    //callAPI and setProrate charge
    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/get_prorate_value`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
        },
        params: {
          plan_id: planId,
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setProrateValue(res.data.result.prorated_value);
            setProrateCurrency(res.data.result.currency);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
        });
    }
  };

  const selectUpdatePlan = (planId, planName, type) => {
    setUpdateStatusMessage("");
    setUpdatePlanType(planName);
    setUpdatePlanId(planId);
    if (type === "DOWN") {
      setUpdateCardType("DOWN");
      setShowDowngradeCard(true);
    } else {
      setUpdateCardType("UP");
      setProrateChargeForToday(planId);
      setShowUpgradeCard(true);
    }
  };

  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";
    const isFree = ReactSession.get("ifr") ?? "unknown";
    //console.log(isFree);
    if (isFree === "Free") props.setFreeUser(true);
    else props.setFreeUser(false);
    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}pricing`,
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "69420",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            // setFreePlanSpecs(res.data.result.plans.find(plan => plan.name === 'FREE'));
            // setHackPlanSpecs(res.data.result.plans.find(plan => plan.name === 'HACK'));
            // setLaunchPlanSpecs(res.data.result.plans.find(plan => plan.name === 'LAUNCH'));
            // setScalePlanSpecs(res.data.result.plans.find(plan => plan.name === 'SCALE'));
            setData(res.data);
          } else {
            setErrOcc(true);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setErrOcc(true);
        })
        .finally(() => {
          props.setLoading(false);
        });
    } else {
      navigate("/get-api-key");
    }
  }, []);

  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";
    const expiryDate = ReactSession.get("ceDt") ?? "";
    setCurrentSubscriptionEndDate(expiryDate);
    if (token !== "" && props.combinedPlanName.toUpperCase() === "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/overview`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            props.setCurrentPlan(res.data.result.current_plan ?? "FREE");
            if (res.data.result.current_plan === "FREE")
              ReactSession.set("ifr", "Free");
            else ReactSession.set("ifr", "Paid");
            ReactSession.set(
              "ceDt",
              `${new Date(res.data.result.cycle_end).getUTCDate()}- 
                        ${
                          months[
                            new Date(res.data.result.cycle_end).getUTCMonth()
                          ]
                        }
                        ${new Date(res.data.result.cycle_end).getUTCFullYear()}`
            );
            setCurrentSubscriptionEndDate(`${new Date(
              res.data.result.cycle_end
            ).getUTCDate()}- 
                        ${
                          months[
                            new Date(res.data.result.cycle_end).getUTCMonth()
                          ]
                        }
                        ${new Date(
                          res.data.result.cycle_end
                        ).getUTCFullYear()}`);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          // setErrOcc(true);
          // props.setLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    if (data !== null || errOcc === true) {
      props.setLoading(false);

      // setTimeout(() => {
      //     const isUserOnFreePlan = ReactSession.get("ifr") ?? "unknown";
      //     if(props.combinedPlanName.toUpperCase() === "FREE")
      //     {
      //         console.log(props.combinedPlanName.toUpperCase());
      //         const planToActivate = queryParameters.get("activatePlan");
      //         selectPlanAndPay(planToActivate.toUpperCase());
      //     }
      // }, 500);
    }
  }, [data, errOcc]);

  useEffect(() => {
    //console.log(props.combinedPlanName.toUpperCase())
    setTimeout(() => {
      const isUserOnFreePlan = ReactSession.get("ifr") ?? "unknown";
      //console.log(isUserOnFreePlan)
      const planToActivate = queryParameters.get("activatePlan") ?? null;
      if (isUserOnFreePlan?.toUpperCase() === "FREE" && planToActivate) {
        //console.log(props.combinedPlanName.toUpperCase());

        selectPlanAndPay(planToActivate.toUpperCase());
      }
    }, 100);
  }, [props.isLoading]);

  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";
    const rewardSysActive = process.env.REACT_APP_REWARD_SYSTEM ?? "inactive";
    if (token !== "" && rewardSysActive === "active") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/reward/all`,
        method: "GET",
        // headers: {
        //     'Authorization': `Bearer ${token}`,
        //     "ngrok-skip-browser-warning": "69420"
        // }
      })
        .then((res) => {
          if (res.data.success === true) {
            setOfferData(res.data.result ?? []);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          // setErrOcc(true);
          // props.setLoading(false);
        });
    }
  }, []);

  const changePlanNow = (type) => {
    setUpdateStatus("CHANGING");
    setUpdateStatusMessage("");
    const endPoint = process.env.REACT_APP_AUTH_EP;
    const token = ReactSession.get("xTkn") ?? "";
    if (type === "UP") {
      axios({
        url: `${endPoint}dashboard/upgrade_plan`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        data: {
          plan_id: updatePlanId,
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setUpdateStatus("CHANGED");
            setUpdatePlanId("");
            // props.setCurrentPlan("FREE");
            // ReactSession.set("ifr", "FREE");
          } else if (res.data.error.startsWith("Invoice is already paid")) {
            setUpdateStatus("CHANGED");
            setUpdatePlanId("");
          } else {
            setUpdateStatusMessage(
              "Error while changing plan. Please reachout to us."
            );
            setUpdatePlanId("");
            setUpdateStatus("UNCHANGED");
          }
          setTimeout(() => {
            setUpdateStatus("NO_ACTION");
            setShowUpgradeCard(false);
            navigate(0);
          }, 1000);
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err?.message);
          if (
            err?.response?.data?.error.startsWith("Invoice is already paid") || err?.message?.startsWith("Invoice is already paid")
          ) {
            setUpdateStatus("CHANGED");
            setUpdatePlanId("");
            setTimeout(() => {
              setUpdateStatus("NO_ACTION");
              setShowUpgradeCard(false);
              navigate(0);
            }, 1000);
          }
          if (
            err?.response?.data?.error.startsWith(
              "You cannot migrate a subscription"
            )
          ) {
            setUpdateStatusMessage(
              "You have already switched your plan. Please reach out to us for more info."
            );
          }

          setUpdateStatusMessage(
            "Error while changing plan. Please reachout to us."
          );
          setUpdatePlanId("");
          setUpdateStatus("UNCHANGED");
          setTimeout(() => {
            setUpdateStatus("NO_ACTION");
            setShowUpgradeCard(false);
          }, 2500);
        });
    } else {
      axios({
        url: `${endPoint}dashboard/downgrade_plan`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        data: {
          plan_id: updatePlanId,
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setUpdateStatus("CHANGED");
            setUpdatePlanId("");
            // props.setCurrentPlan("FREE");
            // ReactSession.set("ifr", "FREE");
          } else {
            setUpdateStatusMessage(
              "Error while changing plan. Please reachout to us."
            );
            setUpdatePlanId("");
            setUpdateStatus("UNCHANGED");
          }
          setTimeout(() => {
            setUpdateStatus("NO_ACTION");
            setShowDowngradeCard(false);
          }, 1000);
        })
        // Catch errors if any
        .catch((err) => {
          //console.warn(err);
          if (
            err?.response?.data?.error.startsWith(
              "You cannot migrate a subscription"
            )
          )
            setUpdateStatusMessage(
              "You have already switched your plan. Please reach out to us for more info."
            );
          else
            setUpdateStatusMessage(
              "Error while changing plan. Please reach out to us on dashboard support."
            );
          setUpdatePlanId("");
          setUpdateStatus("UNCHANGED");
          setTimeout(() => {
            setUpdateStatus("NO_ACTION");
            setShowDowngradeCard(false);
          }, 4000);
        });
    }
  };

  return (
    <div>
      <div>
        <Modal
          isOpen={showUpgradeCard}
          onClose={() => setShowUpgradeCard(false)}
          blockScrollOnMount={true}
        >
          <ModalOverlay />
          <ModalContent
            bg={"brand.black"}
            border={"1px solid"}
            borderColor={"brand.midGrey"}
            borderRadius={"xl"}
          >
            <ModalCloseButton />
            <ModalBody py={4}>
              <Text
                as="div"
                fontSize={{ base: "md", md: "md" }}
                fontWeight={"600"}
                color={"brand.white"}
                textAlign={"center"}
                fontFamily={"heading"}
              >
                Are you sure you want to upgrade to{" "}
                <Text as="span" color={"brand.red"}>
                  {updatePlanType}
                </Text>{" "}
                plan?
              </Text>
              <Text
                as="div"
                fontSize={{ base: "xs", md: "sm" }}
                fontWeight={"400"}
                color={"brand.white"}
                textAlign={"center"}
                mt={4}
              >
                You will be billed{" "}
                <Text as="span" color={"brand.yellow"}>
                  {prorateCurrency === "inr" ? "₹" : "$"}
                  {prorateValue}
                </Text>
                .
              </Text>
              <Text
                as="div"
                fontSize={{ base: "xs", md: "xs" }}
                fontWeight={"600"}
                color={"brand.red"}
                textAlign={"start"}
                mt={4}
              >
                {updateStatusMessage}
              </Text>
            </ModalBody>
            <ModalFooter>
              {updateStatus === "NO_ACTION" && (
                <Flex width={"100%"} justifyContent={"center"}>
                  <Button
                    colorScheme="blue"
                    mr={3}
                    onClick={() => {
                      changePlanNow("UP");
                    }}
                    color={"brand.dark"}
                    bg={"brand.white"}
                    _hover={{
                      bg: "brand.black",
                      color: "brand.white",
                    }}
                    px={"20px"}
                    fontFamily={"heading"}
                    fontSize={"12px"}
                    lineHeight={"12px"}
                    size={"sm"}
                    borderRadius={"full"}
                  >
                    Yes
                  </Button>
                  <Button
                    colorScheme="blue"
                    mr={3}
                    onClick={() => {
                      setShowUpgradeCard(false);
                    }}
                    color={"brand.dark"}
                    bg={"brand.white"}
                    _hover={{
                      bg: "brand.black",
                      color: "brand.white",
                    }}
                    px={"20px"}
                    fontFamily={"heading"}
                    fontSize={"12px"}
                    lineHeight={"12px"}
                    size={"sm"}
                    borderRadius={"full"}
                  >
                    No
                  </Button>
                </Flex>
              )}
              {updateStatus === "CHANGING" && (
                <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                  <BeatLoader color="#fff" loading={true} size={10} />
                </Flex>
              )}
              {updateStatus === "CHANGED" && (
                <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                  <FaCheck color="#39e75f" />
                </Flex>
              )}
              {updateStatus === "UNCHANGED" && (
                <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                  <ImCross color="#e3242b" />
                </Flex>
              )}
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal
          isOpen={showDowngradeCard}
          onClose={() => setShowDowngradeCard(false)}
          blockScrollOnMount={true}
        >
          <ModalOverlay />
          <ModalContent
            bg={"brand.black"}
            border={"1px solid"}
            borderColor={"brand.midGrey"}
            borderRadius={"xl"}
          >
            <ModalCloseButton />
            <ModalBody py={4}>
              <Text
                as="div"
                fontSize={{ base: "md", md: "md" }}
                fontWeight={"600"}
                color={"brand.white"}
                textAlign={"center"}
                fontFamily={"heading"}
              >
                Are you sure you want to switch to{" "}
                <Text as="span" color={"brand.red"}>
                  {updatePlanType}
                </Text>{" "}
                plan?
              </Text>
              <Text
                as="div"
                fontSize={{ base: "xs", md: "sm" }}
                fontWeight={"400"}
                color={"brand.white"}
                textAlign={"center"}
                mt={4}
              >
                {/* Note: The new plan will be applicable from the next billing cycle. */}
                The new plan will be applicable from the next billing cycle.{" "}
                {/* {currentSubscriptionEndDate == "" ? (
                  " the next billing cycle"
                ) : (
                  <Text as="span" color={"brand.yellow"}>
                    {currentSubscriptionEndDate}
                  </Text>
                )}
                . */}
              </Text>
              <Text
                as="div"
                fontSize={{ base: "xs", md: "xs" }}
                fontWeight={"600"}
                color={"brand.red"}
                textAlign={"start"}
                mt={4}
              >
                {updateStatusMessage}
              </Text>
            </ModalBody>
            <ModalFooter>
              {updateStatus === "NO_ACTION" && (
                <Flex width={"100%"} justifyContent={"center"}>
                  <Button
                    colorScheme="blue"
                    mr={3}
                    onClick={() => {
                      changePlanNow("DOWN");
                    }}
                    color={"brand.dark"}
                    bg={"brand.white"}
                    _hover={{
                      bg: "brand.black",
                      color: "brand.white",
                    }}
                    px={"20px"}
                    fontFamily={"heading"}
                    fontSize={"12px"}
                    lineHeight={"12px"}
                    size={"sm"}
                    borderRadius={"full"}
                  >
                    Yes
                  </Button>
                  <Button
                    colorScheme="blue"
                    mr={3}
                    onClick={() => {
                      setShowDowngradeCard(false);
                    }}
                    color={"brand.dark"}
                    bg={"brand.white"}
                    _hover={{
                      bg: "brand.black",
                      color: "brand.white",
                    }}
                    px={"20px"}
                    fontFamily={"heading"}
                    fontSize={"12px"}
                    lineHeight={"12px"}
                    size={"sm"}
                    borderRadius={"full"}
                  >
                    No
                  </Button>
                </Flex>
              )}
              {updateStatus === "CHANGING" && (
                <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                  <BeatLoader color="#fff" loading={true} size={10} />
                </Flex>
              )}
              {updateStatus === "CHANGED" && (
                <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                  <FaCheck color="#39e75f" />
                </Flex>
              )}
              {updateStatus === "UNCHANGED" && (
                <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                  <ImCross color="#e3242b" />
                </Flex>
              )}
            </ModalFooter>
          </ModalContent>
        </Modal>
        <div>
          {!props.isLoading && (
            <Container maxW={"8xl"}>
              <Box
                as="div"
                // px={{ base: '16px', md: '24px', xl: '32px' }}
                // py={{ base: '16px', md: '24px' }}
                borderRadius={"14px"}
              >
                <Box>
                  <Text
                    as={"div"}
                    fontFamily={"heading"}
                    color={"brand.white"}
                    fontSize={"2xl"}
                    lineHeight={"3xl"}
                    fontWeight={"600"}
                    position={"relative"}
                  >
                    Manage your Subscription
                    <br />
                    {/* <ChakraLink
                      id="offer_button"
                      href="/dashboard/pricing#nft_offers"
                      fontFamily={"heading"}
                      fontSize={{ base: "12px" }}
                      fontWeight={"300"}
                      marginTop={"8px"}
                      marginLeft={"10px"}
                      backgroundColor={"brand.red"}
                      py={0.5}
                      px={2.5}
                      borderRadius={6}
                      position={"absolute"}
                      _hover={{
                        textDecoration: "none",
                        color: "brand.white",
                      }}
                    >
                      View Offers
                    </ChakraLink> */}
                  </Text>
                  {props.combinedPlanName.toUpperCase() === "FREE" ? (
                    <Text
                      as={"div"}
                      fontSize={{ base: "14px", lg: "md" }}
                      fontWeight={"400"}
                      color={"brand.lighterWhite"}
                      pt={{ base: "4px", md: "6px" }}
                    >
                      Get your super powers with simple and transparent plans.
                    </Text>
                  ) : (
                    <Text
                      as={"div"}
                      fontSize={{ base: "14px", lg: "md" }}
                      fontWeight={"400"}
                      color={"brand.lighterWhite"}
                      pt={{ base: "4px", md: "6px" }}
                    >
                      {/* Reach out to us on */}{" "}
                      {/* <Text
                        as={"a"}
                        href="https://discord.gg/8JyZCjRPmr"
                        target="_blank"
                        color={"brand.yellow"}
                        _hover={{ color: "brand.red" }}
                      >
                        discord
                      </Text>{" "}
                      to upgrade your plan. */}
                      View your plan details or switch to a different subscription plan.
                    </Text>
                  )}
                </Box>
              </Box>

              <Box mt={2}>
                <Stack
                  as="div"
                  spacing={{ base: 5 }}
                  pt={{ base: 3, md: 3 }}
                  pb={{ base: 6, md: 6 }}
                >
                  <Box>
                    <Tabs variant="unstyled" isFitted mb={10} pt={10} index={tabIndex} onChange={(i) => setTabIndex(i)}>
                      <Flex w="full" justifyContent={"space-between"} alignItems={"center"} mb={8}>
                        <Box flex={1}>
                          <Flex
                            display="inline-flex"
                            alignItems={"center"}
                            border="1px solid"
                            borderColor="brand.faintGrey"
                            borderRadius="full"
                            overflow="hidden"
                          >
                            {[
                              { label: "Monthly", subLabel: "", value: 1 },
                              { label: "Quarterly", subLabel: "10%", value: 3 },
                              { label: "Semi-Annual", subLabel: "20%", value: 6 },
                            ].map(({ label, subLabel, value }) => (
                              <Button
                                key={value}
                                onClick={() => setBillingCycle(value)}
                                px={8}
                                pt={"10px"}
                                pb={2}
                                borderRadius="full"
                                bg={billingCycle === value ? "brand.red" : "transparent"}
                                _hover={{
                                  bg: billingCycle === value ? "brand.red" : "brand.redFade",
                                }}
                                _active={{ bg: "brand.red", color: "brand.white" }}
                                transition="all 0.2s"
                              >
                                <Text as={"div"} fontWeight="700" fontSize="sm" color={billingCycle === value ? "brand.white" : "brand.lighterWhite"} transition="all 0.2s">
                                  {label}
                                </Text>
                                {subLabel !== "" && (
                                  <Badge
                                      ml="1"
                                      mt={"-1px"}
                                      bg={"brand.yellow"}
                                      color={"brand.black"}
                                      me={1}
                                      textTransform={"lowercase"}
                                      fontWeight={600}
                                      pt="2px"
                                  >
                                      {subLabel} Off
                                  </Badge>
                                )}
                              </Button>
                            ))}
                          </Flex>

                          <TabList display="none">
                            <Tab>Unlimited RPCs + gRPC</Tab>
                            <Tab>Legacy Plans</Tab>
                          </TabList>
                        </Box>
                        <Box flex={1}>
                          <FormControl display="flex" alignItems="center" justifyContent={"end"}>
                            <FormLabel htmlFor="legacy-plans-toggle" mb="0" color={"brand.lighterWhite"}>
                              Legacy Plans?
                            </FormLabel>
                            <Switch
                              id="legacy-plans-toggle"
                              colorScheme="red"
                              isChecked={tabIndex === 1}
                              onChange={(e) => setTabIndex(e.target.checked ? 1 : 0)}
                            />
                          </FormControl>
                        </Box>
                      </Flex>

                      <TabPanels>
                        {/* Shared gRPC Network Panel */}
                        <TabPanel p={0}>
                          <Box
                            bg={"transparent"}
                            borderRadius="xl"
                            border="1px solid"
                            borderColor={"transparent"}
                            overflow="hidden"
                            boxShadow="lg"
                          >
                            <Stack
                              as="div"
                              spacing={{ base: 5 }}
                              pt={{ base: 6, md: 3 }}
                              pb={{ base: 6, md: 8 }}
                            >
                              <Flex
                                justifyContent={{
                                  base: "space-around",
                                  xl: "space-between",
                                }}
                                flexWrap={"wrap"}
                              >
                                <Stack
                                  border={"2px solid"}
                                  borderColor={
                                    props.combinedPlanName.toUpperCase() === "FREE"
                                      ? "brand.red"
                                      : "brand.lightGray"
                                  }
                                  boxShadow={
                                    props.combinedPlanName.toUpperCase() === "FREE"
                                      ? "0px 2px 12px #ff000099"
                                      : ""
                                  }
                                  py={8}
                                  px={6}
                                  width="325px"
                                  mt={6}
                                  className="each_plan"
                                  initial={{ opacity: 0, y: 10 }}
                                  whileInView={{ opacity: 1, y: 0 }}
                                  viewport={{ once: true }}
                                  transition={{ duration: 0.3, delay: 0.3 }}
                                  bg={"#000"}
                                >
                                  <Box
                                    maxW={"48px"}
                                    transform={"rotate(20deg)"}
                                  >
                                    <FaPaperPlane size={"24"} color="#E33535" />
                                  </Box>
                                  <Text
                                    as={"div"}
                                    textAlign={"start"}
                                    fontSize={"4xl"}
                                    color={"brand.white"}
                                    fontFamily={"heading"}
                                    fontWeight={"700"}
                                  >
                                    Free
                                  </Text>

                                  <Flex justifyContent={"start"}>
                                    <Box>
                                      <Text
                                        as={"div"}
                                        fontSize={"2xl"}
                                        fontWeight={"500"}
                                        color={"brand.white"}
                                        fontFamily={"heading"}
                                        px={1}
                                      >
                                        $0
                                        <Text
                                          as={"span"}
                                          fontSize={"lg"}
                                          fontWeight={"400"}
                                          color={"brand.lightGray"}
                                          opacity={0.5}
                                        >
                                          /month
                                        </Text>
                                      </Text>
                                    </Box>
                                  </Flex>

                                  <Stack mt={6}>
                                    <Stack spacing={3}>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Unlimited Credits
                                        </Text>
                                      </Stack>

                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          10 RPC req/sec
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color={"brand.midGrey"}
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No gRPC Access
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color={"brand.midGrey"}
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No RabbitStream Access
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color={"brand.midGrey"}
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No Accelerated gPA
                                        </Text>
                                      </Stack>

                                      
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          1 API req/sec
                                        </Text>
                                      </Stack>
                                      
                                    </Stack>
                                  </Stack>
                                  <Stack direction={"row"}>
                                    <Box>
                                      <Box pt={"2px"}>
                                        <ImCross
                                          color="#808080"
                                          size={15}
                                          opacity={0.4}
                                        />
                                      </Box>
                                    </Box>
                                    <Text
                                      as={"div"}
                                      fontFamily={"Jost"}
                                      fontSize={{ base: "14px", md: "md" }}
                                      color="brand.midGrey"
                                      fontWeight={"500"}
                                      opacity={0.4}
                                    >
                                      {" "}
                                      Staked Connections
                                    </Text>
                                  </Stack>
                                  <Box
                                    textAlign={"start"}
                                    pt={"18px"}
                                    height={"60px"}
                                  >
                                    <Box as="a" href={`#compare-plans`}>
                                      <Stack direction={"row"} cursor={"pointer"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FiChevronsDown color="#E33535" className="know_more_arrow" size={"20px"}/>
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                          className="each_plan_text_button"
                                        >
                                          {" "}
                                          Know More
                                        </Text>
                                      </Stack>
                                    </Box>
                                  </Box>

                                  <Box w={"100%"} height={"4px"}></Box>

                                  <Box ps={"2px"} height={"20px"} mb={-4}>
                                  </Box>

                                  <Stack>
                                    <Link
                                      //href={"/dashboard/pricing"}
                                      _hover={{
                                        textDecoration: "none",
                                      }}
                                    >
                                      <Box
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        border={"1px solid"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        fontSize={{ base: "sm", md: "sm" }}
                                        lineHeight={"38px"}
                                        paddingTop={"2px"}
                                        textAlign={"center"}
                                        mt={4}
                                        _hover={{
                                          textDecoration: "none",
                                        }}
                                      >
                                        Default
                                      </Box>
                                    </Link>
                                  </Stack>
                                </Stack>

                                <Stack
                                  border={"2px solid"}
                                  borderColor={
                                    props.combinedPlanName.toUpperCase() === "BUILD"
                                      ? "brand.red"
                                      : "brand.lightGray"
                                  }
                                  boxShadow={
                                    props.combinedPlanName.toUpperCase() === "BUILD"
                                      ? "0px 2px 12px #ff000099"
                                      : ""
                                  }
                                  py={8}
                                  px={6}
                                  width="325px"
                                  mt={6}
                                  className="each_plan"
                                  bg={"#000"}
                                >
                                  <Box maxW={"48px"}>
                                    <FaFly size={"24"} color="#E33535" />
                                  </Box>
                                  <Text
                                    as={"div"}
                                    textAlign={"start"}
                                    fontSize={"4xl"}
                                    color={"brand.white"}
                                    fontFamily={"heading"}
                                    fontWeight={"700"}
                                  >
                                    Build
                                  </Text>

                                  <Flex justifyContent={"start"}>
                                    <Box>
                                      <Text
                                          as={'div'}
                                          fontSize={'2xl'}
                                          fontWeight={'500'}
                                          color={'brand.white'}
                                          fontFamily={'heading'}
                                          px={1}
                                      >
                                          {billingCycle === 3 && <Text 
                                            as={"span"}
                                            fontSize={'lg'}
                                            fontWeight={'400'}
                                            textDecor={"line-through"}
                                            color={'brand.lightGray'}
                                            opacity={0.5}
                                            me={1}
                                          >
                                              {UNLIMITED_PLAN_PRICES.build.quaterly.productTotal}
                                          </Text>}
                                          {billingCycle === 6 && <Text 
                                            as={"span"}
                                            fontSize={'lg'}
                                            fontWeight={'400'}
                                            textDecor={"line-through"}
                                            color={'brand.lightGray'}
                                            opacity={0.5}
                                            me={1}
                                          >
                                              {UNLIMITED_PLAN_PRICES.build.semiAnually.productTotal}
                                          </Text>}
                                          {billingCycle === 1 && UNLIMITED_PLAN_PRICES.build.monthly}
                                          {billingCycle === 3 && <Text as={"span"} color={"brand.green"}>{UNLIMITED_PLAN_PRICES.build.quaterly.total}</Text>}
                                          {billingCycle === 6 && <Text as={"span"} color={"brand.green"}>{UNLIMITED_PLAN_PRICES.build.semiAnually.total}</Text>}
                                          
                                          <Text
                                              as={'span'}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                          >
                                              {billingCycle === 1 && "/month"} 
                                                {billingCycle === 3 && " /3 mo"} 
                                                {billingCycle === 6 && " /6 mo"} 
                                          </Text>
                                      </Text>
                                    </Box>
                                  </Flex>
                                  

                                  <Stack mt={6}>
                                    <Stack spacing={3}>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Unlimited Credits
                                        </Text>
                                      </Stack>

                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          100 RPC req/sec
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          gRPC Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          RabbitStream Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Accelerated gPA
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          10 API req/sec
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Staked Connections
                                        </Text>
                                      </Stack>
                                    </Stack>
                                  </Stack>

                                  <Box
                                    textAlign={"start"}
                                    pt={"16px"}
                                    height={"52px"}
                                  >
                                    <Box as="a" href={"#compare-plans"}>
                                      <Stack direction={"row"} cursor={"pointer"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FiChevronsDown color="#E33535" className="know_more_arrow" size={"20px"}/>
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                          className="each_plan_text_button"
                                        >
                                          {" "}
                                          Know More
                                        </Text>
                                      </Stack>
                                    </Box>
                                  </Box>
                                  <Box w={"100%"} height={"4px"}></Box>

                                  <Box ps={"2px"} height={"20px"} mb={-4}>
                                    {billingCycle > 1 && (
                                      <Text fontWeight={"medium"} fontSize={"sm"} color={"brand.midGrey"} textAlign={"center"}>
                                        {billingCycle === 3 && `Effectively ${UNLIMITED_PLAN_PRICES.build.quaterly.perMonth}/month`}
                                        {billingCycle === 6 && `Effectively ${UNLIMITED_PLAN_PRICES.build.semiAnually.perMonth}/month`}
                                      </Text>
                                    )}
                                  </Box>

                                  {billingCycle === 1 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ? 
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.build,
                                              "BUILD",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "BUILD",
                                            PlanIds.build
                                          )
                                        }
                                      >
                                        Select Plan
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "BUILD" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["BUILD"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.build,
                                            "BUILD",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.build,
                                            "BUILD",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 3 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ? 
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.buildq,
                                              "BUILD",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade 
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "BUILD",
                                            PlanIds.buildq
                                          )
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "BUILDQ" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["BUILDQ"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.buildq,
                                            "BUILD",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.buildq,
                                            "BUILD",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 6 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ? 
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.builds,
                                              "BUILD",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "BUILD",
                                            PlanIds.builds
                                          )
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "BUILDS" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["BUILDS"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.builds,
                                            "BUILD",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.builds,
                                            "BUILD",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                </Stack>

                                <Stack
                                  border={"2px solid"}
                                  borderColor={
                                    props.combinedPlanName.toUpperCase() === "GROW"
                                      ? "brand.red"
                                      : "brand.lightGray"
                                  }
                                  boxShadow={
                                    props.combinedPlanName.toUpperCase() === "GROW"
                                      ? "0px 2px 12px #ff000099"
                                      : ""
                                  }
                                  py={8}
                                  px={6}
                                  width="325px"
                                  mt={6}
                                  className="each_plan"
                                  initial={{ opacity: 0, y: 10 }}
                                  whileInView={{ opacity: 1, y: 0 }}
                                  viewport={{ once: true }}
                                  transition={{ duration: 0.3, delay: 0.3 }}
                                  bg={"#000"}
                                >
                                  <Box maxW={"48px"}>
                                    <FaPlane
                                      size={"24"}
                                      color="#E33535"
                                    />
                                  </Box>
                                  <Text
                                    as={"div"}
                                    textAlign={"start"}
                                    fontSize={"4xl"}
                                    color={"brand.white"}
                                    fontFamily={"heading"}
                                    fontWeight={"700"}
                                  >
                                    Grow
                                  </Text>

                                  <Flex justifyContent={"start"}>
                                    <Box>
                                        <Text
                                            as={'div'}
                                            fontSize={'2xl'}
                                            fontWeight={'500'}
                                            color={'brand.white'}
                                            fontFamily={'heading'}
                                            px={1}
                                        >
                                            {billingCycle === 3 && <Text 
                                              as={"span"}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              textDecor={"line-through"}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                              me={1}
                                            >
                                                {UNLIMITED_PLAN_PRICES.grow.quaterly.productTotal}
                                            </Text>}
                                            {billingCycle === 6 && <Text 
                                              as={"span"}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              textDecor={"line-through"}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                              me={1}
                                            >
                                                {UNLIMITED_PLAN_PRICES.grow.semiAnually.productTotal}
                                            </Text>}
                                            {billingCycle === 1 && UNLIMITED_PLAN_PRICES.grow.monthly}
                                            {billingCycle === 3 && <Text as={"span"} color={"brand.green"}>{UNLIMITED_PLAN_PRICES.grow.quaterly.total}</Text>}
                                            {billingCycle === 6 && <Text as={"span"} color={"brand.green"}>{UNLIMITED_PLAN_PRICES.grow.semiAnually.total}</Text>}
                                            
                                            <Text
                                                as={'span'}
                                                fontSize={'lg'}
                                                fontWeight={'400'}
                                                color={'brand.lightGray'}
                                                opacity={0.5}
                                            >
                                                {billingCycle === 1 && "/month"} 
                                                  {billingCycle === 3 && " /3 mo"} 
                                                  {billingCycle === 6 && " /6 mo"} 
                                            </Text>
                                        </Text>
                                    </Box>
                                  </Flex>
                                  

                                  <Stack mt={6}>
                                    <Stack spacing={3}>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Unlimited Credits
                                        </Text>
                                      </Stack>

                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          150 RPC req/sec
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          gRPC Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          RabbitStream Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Accelerated gPA
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          30 API req/sec
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Staked Connections
                                        </Text>
                                      </Stack>
                                    </Stack>
                                  </Stack>

                                  <Box
                                    textAlign={"start"}
                                    pt={"16px"}
                                    height={"52px"}
                                  >
                                    <Box as="a" href={"#compare-plans"}>
                                      <Stack direction={"row"} cursor={"pointer"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FiChevronsDown color="#E33535" className="know_more_arrow" size={"20px"}/>
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                          className="each_plan_text_button"
                                        >
                                          {" "}
                                          Know More
                                        </Text>
                                      </Stack>
                                    </Box>
                                  </Box>

                                  <Box w={"100%"} height={"4px"}></Box>
                                  <Box ps={"2px"} height={"20px"} mb={-4}>
                                    {billingCycle > 1 && (
                                      <Text fontWeight={"medium"} fontSize={"sm"} color={"brand.midGrey"} textAlign={"center"}>
                                        {billingCycle === 3 && `Effectively ${UNLIMITED_PLAN_PRICES.grow.quaterly.perMonth}/month`}
                                        {billingCycle === 6 && `Effectively ${UNLIMITED_PLAN_PRICES.grow.semiAnually.perMonth}/month`}
                                      </Text>
                                    )}
                                  </Box>

                                  {billingCycle === 1 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ?
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.grow,
                                              "GROW",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "GROW",
                                            PlanIds.grow
                                          )
                                        }
                                      >
                                        Select Plan
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "GROW" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["GROW"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.grow,
                                            "GROW",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.grow,
                                            "GROW",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 3 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ?
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.growq,
                                              "GROW",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "GROW",
                                            PlanIds.growq
                                          )
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "GROWQ" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["GROWQ"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.growq,
                                            "GROW",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.growq,
                                            "GROW",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 6 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ?
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.grows,
                                              "GROW",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "GROW",
                                            PlanIds.grows
                                          )
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "GROWS" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["GROWS"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.grows,
                                            "GROW",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.grows,
                                            "GROW",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                </Stack>

                                <Stack
                                  border={"2px solid"}
                                  borderColor={
                                    props.combinedPlanName.toUpperCase() === "ACCELERATE"
                                      ? "brand.red"
                                      : "brand.lightGray"
                                  }
                                  boxShadow={
                                    props.combinedPlanName.toUpperCase() === "ACCELERATE"
                                      ? "0px 2px 12px #ff000099"
                                      : ""
                                  }
                                  py={8}
                                  px={6}
                                  width="325px"
                                  mt={6}
                                  className="each_plan"
                                  initial={{ opacity: 0, y: 10 }}
                                  whileInView={{ opacity: 1, y: 0 }}
                                  viewport={{ once: true }}
                                  transition={{ duration: 0.3, delay: 0.3 }}
                                  bg={"#000"}
                                >
                                  <Box maxW={"48px"}>
                                    <IoRocketSharp
                                      size={"24"}
                                      color="#E33535"
                                    />
                                  </Box>
                                  <Text
                                    as={"div"}
                                    textAlign={"start"}
                                    fontSize={"4xl"}
                                    color={"brand.white"}
                                    fontFamily={"heading"}
                                    fontWeight={"700"}
                                  >
                                    Accelerate
                                  </Text>

                                  <Flex justifyContent={"start"}>
                                    <Box>
                                      <Text
                                          as={'div'}
                                          fontSize={'2xl'}
                                          fontWeight={'500'}
                                          color={'brand.white'}
                                          fontFamily={'heading'}
                                          px={1}
                                      >
                                        {billingCycle === 3 && <Text 
                                            as={"span"}
                                            fontSize={'lg'}
                                            fontWeight={'400'}
                                            textDecor={"line-through"}
                                            color={'brand.lightGray'}
                                            opacity={0.5}
                                            me={1}
                                          >
                                              {UNLIMITED_PLAN_PRICES.accelerate.quaterly.productTotal}
                                          </Text>}
                                          {billingCycle === 6 && <Text 
                                            as={"span"}
                                            fontSize={'lg'}
                                            fontWeight={'400'}
                                            textDecor={"line-through"}
                                            color={'brand.lightGray'}
                                            opacity={0.5}
                                            me={1}
                                          >
                                              {UNLIMITED_PLAN_PRICES.accelerate.semiAnually.productTotal}
                                          </Text>}
                                          {billingCycle === 1 && UNLIMITED_PLAN_PRICES.accelerate.monthly}
                                          {billingCycle === 3 && <Text as={"span"} color={"brand.green"}>{UNLIMITED_PLAN_PRICES.accelerate.quaterly.total}</Text>}
                                          {billingCycle === 6 && <Text as={"span"} color={"brand.green"}>{UNLIMITED_PLAN_PRICES.accelerate.semiAnually.total}</Text>}

                                          
                                          
                                          <Text
                                              as={'span'}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                          >
                                              {billingCycle === 1 && "/month"} 
                                                {billingCycle === 3 && " /3 mo"} 
                                                {billingCycle === 6 && " /6 mo"} 
                                          </Text>
                                      </Text>
                                  </Box>
                                  </Flex>
                                  

                                  <Stack mt={6}>
                                    <Stack spacing={3}>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Unlimited Credits
                                        </Text>
                                      </Stack>

                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          400 RPC req/sec
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          gRPC Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          RabbitStream Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Accelerated gPA
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          100 API req/sec
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Staked Connections
                                        </Text>
                                      </Stack>
                                    </Stack>
                                  </Stack>

                                  <Box
                                    textAlign={"start"}
                                    height={"52px"}
                                    pt={"16px"}
                                  >
                                    <Box as="a" href={"#compare-plans"}>
                                      <Stack direction={"row"} cursor={"pointer"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FiChevronsDown color="#E33535" className="know_more_arrow" size={"20px"}/>
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                          className="each_plan_text_button"
                                        >
                                          {" "}
                                          Know More
                                        </Text>
                                      </Stack>
                                    </Box>
                                  </Box>

                                  <Box w={"100%"} height={"4px"}></Box>

                                  <Box ps={"2px"} height={"20px"} mb={-4}>
                                    {billingCycle > 1 && (
                                      <Text fontWeight={"medium"} fontSize={"sm"} color={"brand.midGrey"} textAlign={"center"}>
                                        {billingCycle === 3 && `Effectively ${UNLIMITED_PLAN_PRICES.accelerate.quaterly.perMonth}/month`}
                                        {billingCycle === 6 && `Effectively ${UNLIMITED_PLAN_PRICES.accelerate.semiAnually.perMonth}/month`}
                                      </Text>
                                    )}
                                  </Box>

                                  {billingCycle === 1 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ?
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.accelerate,
                                              "ACCELERATE",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "ACCELERATE",
                                            PlanIds.accelerate
                                          )
                                        }
                                      >
                                        Select Plan
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "ACCELERATE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["ACCELERATE"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.accelerate,
                                            "ACCELERATE",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.accelerate,
                                            "ACCELERATE",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 3 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ?
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.accelerateq,
                                              "ACCELERATE",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "ACCELERATE",
                                            PlanIds.accelerateq
                                          )
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "ACCELERATEQ" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["ACCELERATEQ"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.accelerateq,
                                            "ACCELERATE",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.accelerateq,
                                            "ACCELERATE",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 6 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? ( props.grpcPaymentInfoPresent ?
                                      <Button
                                          size={"sm"}
                                          width={"full"}
                                          height={"10"}
                                          margin={"0 auto"}
                                          variant={"outline"}
                                          borderColor={"brand.red"}
                                          borderRadius={"full"}
                                          className="each_plan_button"
                                          fontFamily={"heading"}
                                          fontWeight={"500"}
                                          mt={4}
                                          onClick={() =>
                                            selectUpdatePlan(
                                              PlanIds.accelerates,
                                              "ACCELERATE",
                                              "UP"
                                            )
                                          }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                      :<Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay(
                                            "ACCELERATE",
                                            PlanIds.accelerates
                                          )
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "ACCELERATES" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["ACCELERATES"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.accelerates,
                                            "ACCELERATE",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.accelerates,
                                            "ACCELERATE",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                </Stack>
                              </Flex>
                            </Stack>
                          </Box>
                        </TabPanel>

                        {/* Dedicated gRPC Nodes Panel */}
                        <TabPanel p={0}>
                          <Box
                            bg={"transparent"}
                            borderRadius="xl"
                            border="1px solid"
                            borderColor={"transparent"}
                            overflow="hidden"
                            boxShadow="lg"
                          >
                            <Stack
                              as="div"
                              spacing={{ base: 5 }}
                              pt={{ base: 6, md: 3 }}
                              pb={{ base: 6, md: 8 }}
                            >
                              <Flex
                                justifyContent={{
                                  base: "space-around",
                                  xl: "space-between",
                                }}
                                flexWrap={"wrap"}
                              >
                                <Stack
                                  border={"2px solid"}
                                  borderColor={
                                    props.combinedPlanName.toUpperCase() === "FREE"
                                      ? "brand.red"
                                      : "brand.lightGray"
                                  }
                                  boxShadow={
                                    props.combinedPlanName.toUpperCase() === "FREE"
                                      ? "0px 2px 12px #ff000099"
                                      : ""
                                  }
                                  py={8}
                                  px={6}
                                  width="325px"
                                  mt={6}
                                  className="each_plan"
                                  bg={"#000"}
                                >
                                  <Box
                                    maxW={"48px"}
                                    transform={"rotate(20deg)"}
                                  >
                                    <FaPaperPlane size={"24"} color="#E33535" />
                                  </Box>
                                  <Text
                                    as={"div"}
                                    textAlign={"start"}
                                    fontSize={"4xl"}
                                    color={"brand.white"}
                                    fontFamily={"heading"}
                                    fontWeight={"700"}
                                  >
                                    Free
                                  </Text>

                                  <Flex justifyContent={"start"}>
                                    <Box>
                                      <Text
                                        as={"div"}
                                        fontSize={"2xl"}
                                        fontWeight={"500"}
                                        color={"brand.white"}
                                        fontFamily={"heading"}
                                        px={1}
                                      >
                                        $0
                                        <Text
                                          as={"span"}
                                          fontSize={"lg"}
                                          fontWeight={"400"}
                                          color={"brand.lightGray"}
                                          opacity={0.5}
                                        >
                                          /month
                                        </Text>
                                      </Text>
                                    </Box>
                                  </Flex>

                                  <Stack mt={6}>
                                    <Stack spacing={3}>
                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Unlimited Credits
                                        </Text>
                                      </Stack>

                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          10 RPC req/sec
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color={"brand.midGrey"}
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No gRPC Access
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color={"brand.midGrey"}
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No Accelerated gPA
                                        </Text>
                                      </Stack>

                                      
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          1 API req/sec
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No Auto-Scaling
                                        </Text>
                                      </Stack>
                                      
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          Staked Connections
                                        </Text>
                                      </Stack>
                                    </Stack>
                                  </Stack>

                                  <Box
                                    textAlign={"center"}
                                    pt={"4px"}
                                    height={"46px"}
                                  ></Box>

                                  <Box ps={"2px"} height={"20px"} mb={-4}>
                                    
                                  </Box>

                                  <Stack
                                    as="div"
                                    h={{ base: "0px", md: "20px" }}
                                    w={{ base: "0px", md: "20px" }}
                                  ></Stack>

                                  <Stack>
                                    <Link
                                      as={"a"}
                                      // href={"/dashboard/pricing"}
                                      _hover={{
                                        textDecoration: "none",
                                      }}
                                    >
                                      <Box
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        border={"1px solid"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        fontSize={{ base: "sm", md: "sm" }}
                                        lineHeight={"38px"}
                                        paddingTop={"0px"}
                                        textAlign={"center"}
                                        mt={4}
                                        _hover={{
                                          textDecoration: "none",
                                        }}
                                      >
                                        Default
                                      </Box>
                                    </Link>
                                  </Stack>
                                </Stack>

                                <Stack
                                  border={"2px solid"}
                                  borderColor={
                                    props.combinedPlanName.toUpperCase() === "HACK"
                                      ? "brand.red"
                                      : "brand.lightGray"
                                  }
                                  boxShadow={
                                    props.combinedPlanName.toUpperCase() === "HACK"
                                      ? "0px 2px 12px #ff000099"
                                      : ""
                                  }
                                  py={8}
                                  px={6}
                                  width="325px"
                                  mt={6}
                                  className="each_plan"
                                  bg={"#000"}
                                >
                                  <Box maxW={"48px"}>
                                    <FaHammer size={"24"} color="#E33535" />
                                  </Box>
                                  <Text
                                    as={"div"}
                                    textAlign={"start"}
                                    fontSize={"4xl"}
                                    color={"brand.white"}
                                    fontFamily={"heading"}
                                    fontWeight={"700"}
                                  >
                                    Hack
                                  </Text>

                                  <Flex justifyContent={"start"}>
                                    <Box>
                                        <Text
                                            as={'div'}
                                            fontSize={'2xl'}
                                            fontWeight={'500'}
                                            color={'brand.white'}
                                            fontFamily={'heading'}
                                            px={1}
                                        >
                                            {billingCycle === 3 && <Text 
                                              as={"span"}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              textDecor={"line-through"}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                              me={1}
                                            >
                                                {LEGACY_PLAN_PRICES.hack.quaterly.productTotal}
                                            </Text>}
                                            {billingCycle === 6 && <Text 
                                              as={"span"}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              textDecor={"line-through"}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                              me={1}
                                            >
                                                {LEGACY_PLAN_PRICES.hack.semiAnually.productTotal}
                                            </Text>}
                                            {billingCycle === 1 && LEGACY_PLAN_PRICES.hack.monthly}
                                            {billingCycle === 3 && <Text as={"span"} color={"brand.green"}>{LEGACY_PLAN_PRICES.hack.quaterly.total}</Text>}
                                            {billingCycle === 6 && <Text as={"span"} color={"brand.green"}>{LEGACY_PLAN_PRICES.hack.semiAnually.total}</Text>}
                                            
                                            <Text
                                                as={'span'}
                                                fontSize={'lg'}
                                                fontWeight={'400'}
                                                color={'brand.lightGray'}
                                                opacity={0.5}
                                            >
                                                {billingCycle === 1 && "/month"} 
                                                  {billingCycle === 3 && " /3 mo"} 
                                                  {billingCycle === 6 && " /6 mo"} 
                                            </Text>
                                        </Text>
                                    </Box>
                                  </Flex>
                                  

                                  <Stack mt={6}>
                                    <Stack spacing={3}>
                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          10M Credits every month
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          50 RPC req/sec
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color={"brand.midGrey"}
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No gRPC Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Accelerated gPA
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          10 API req/sec
                                        </Text>
                                      </Stack>
                                      
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No Auto-Scaling
                                        </Text>
                                      </Stack>
                                      
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Staked Connections
                                        </Text>
                                      </Stack>
                                    </Stack>
                                  </Stack>

                                  <Box
                                    textAlign={"center"}
                                    pt={"24px"}
                                    height={"40px"}
                                  ></Box>

                                  <Stack
                                    as="div"
                                    h={{ base: "0px", md: "22px" }}
                                    w={{ base: "0px", md: "22px" }}
                                  ></Stack>

                                  <Box ps={"2px"} height={"20px"} mb={-4}>
                                    {billingCycle > 1 && (
                                      <Text fontWeight={"medium"} fontSize={"sm"} color={"brand.midGrey"} textAlign={"center"}>
                                        {billingCycle === 3 && `Effectively ${LEGACY_PLAN_PRICES.hack.quaterly.perMonth}/month`}
                                        {billingCycle === 6 && `Effectively ${LEGACY_PLAN_PRICES.hack.semiAnually.perMonth}/month`}
                                      </Text>
                                    )}
                                  </Box>

                                  {billingCycle === 1 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("HACK", PlanIds.hack)
                                        }
                                      >
                                        Select Plan
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "HACK" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["HACK"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.hack,
                                            "HACK",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.hack,
                                            "HACK",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 3 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("HACK", PlanIds.hackq)
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "HACKQ" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["HACKQ"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.hackq,
                                            "HACK",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.hackq,
                                            "HACK",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 6 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("HACK", PlanIds.hacks)
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "HACKS" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["HACKS"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.hacks,
                                            "HACK",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.hacks,
                                            "HACK",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                </Stack>

                                <Stack
                                  border={"2px solid"}
                                  borderColor={
                                    props.combinedPlanName.toUpperCase() === "LAUNCH"
                                      ? "brand.red"
                                      : "brand.lightGray"
                                  }
                                  boxShadow={
                                    props.combinedPlanName.toUpperCase() === "LAUNCH"
                                      ? "0px 2px 12px #ff000099"
                                      : ""
                                  }
                                  py={8}
                                  px={6}
                                  width="325px"
                                  mt={6}
                                  className="each_plan"
                                  initial={{ opacity: 0, y: 10 }}
                                  whileInView={{ opacity: 1, y: 0 }}
                                  viewport={{ once: true }}
                                  transition={{ duration: 0.3, delay: 0.3 }}
                                  bg={"#000"}
                                >
                                  <Box maxW={"48px"}>
                                    <PiPottedPlantFill size={"24"} color="#E33535" />
                                  </Box>
                                  <Text
                                    as={"div"}
                                    textAlign={"start"}
                                    fontSize={"4xl"}
                                    color={"brand.white"}
                                    fontFamily={"heading"}
                                    fontWeight={"700"}
                                  >
                                    Launch
                                  </Text>

                                  <Flex justifyContent={"start"}>
                                    <Box>
                                      <Text
                                          as={'div'}
                                          fontSize={'2xl'}
                                          fontWeight={'500'}
                                          color={'brand.white'}
                                          fontFamily={'heading'}
                                          px={1}
                                      >
                                          {billingCycle === 3 && <Text 
                                              as={"span"}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              textDecor={"line-through"}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                              me={1}
                                            >
                                                {LEGACY_PLAN_PRICES.launch.quaterly.productTotal}
                                            </Text>}
                                            {billingCycle === 6 && <Text 
                                              as={"span"}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              textDecor={"line-through"}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                              me={1}
                                            >
                                                {LEGACY_PLAN_PRICES.launch.semiAnually.productTotal}
                                            </Text>}
                                          {billingCycle === 1 && LEGACY_PLAN_PRICES.launch.monthly}
                                          {billingCycle === 3 && <Text as={"span"} color={"brand.green"}>{LEGACY_PLAN_PRICES.launch.quaterly.total}</Text>}
                                          {billingCycle === 6 && <Text as={"span"} color={"brand.green"}>{LEGACY_PLAN_PRICES.launch.semiAnually.total}</Text>}
                                          
                                          <Text
                                              as={'span'}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                          >
                                              {billingCycle === 1 && "/month"} 
                                                {billingCycle === 3 && " /3 mo"} 
                                                {billingCycle === 6 && " /6 mo"} 
                                          </Text>
                                      </Text>
                                    </Box>
                                  </Flex>
                                  

                                  <Stack mt={6}>
                                    <Stack spacing={3}>
                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          100M Credits
                                        </Text>
                                      </Stack>

                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          150 RPC req/sec
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color={"brand.midGrey"}
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No gRPC Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Accelerated gPA
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          30 API req/sec
                                        </Text>
                                      </Stack>

                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          $3.33 for each additional 1M credits
                                        </Text>
                                      </Stack>
                                      
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Staked Connections
                                        </Text>
                                      </Stack>
                                    </Stack>
                                  </Stack>

                                  <Box
                                    textAlign={"center"}
                                    pt={"12px"}
                                    height={"19px"}
                                  ></Box>

                                  <Stack
                                    as="div"
                                    h={{ base: "0px", md: "30px" }}
                                    w={{ base: "0px", md: "22px" }}
                                  ></Stack>
                                  <Box ps={"2px"} mt={"-8px"} height={"20px"} mb={-4}>
                                    {billingCycle > 1 && (
                                      <Text fontWeight={"medium"} fontSize={"sm"} color={"brand.midGrey"} textAlign={"center"}>
                                        {billingCycle === 3 && `Effectively ${LEGACY_PLAN_PRICES.launch.quaterly.perMonth}/month`}
                                        {billingCycle === 6 && `Effectively ${LEGACY_PLAN_PRICES.launch.semiAnually.perMonth}/month`}
                                      </Text>
                                    )}
                                  </Box>

                                  {billingCycle === 1 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("LAUNCH", PlanIds.launch)
                                        }
                                      >
                                        Select Plan
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "LAUNCH" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["LAUNCH"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.launch,
                                            "LAUNCH",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.launch,
                                            "LAUNCH",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 3 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("LAUNCH", PlanIds.launchq)
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "LAUNCHQ" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["LAUNCHQ"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.launchq,
                                            "LAUNCH",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.launchq,
                                            "LAUNCH",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 6 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("LAUNCH", PlanIds.launchs)
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "LAUNCHS" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["LAUNCHS"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.launchs,
                                            "LAUNCH",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.launchs,
                                            "LAUNCH",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                </Stack>

                                <Stack
                                  border={"2px solid"}
                                  borderColor={
                                    props.combinedPlanName.toUpperCase() === "SCALE"
                                      ? "brand.red"
                                      : "brand.lightGray"
                                  }
                                  boxShadow={
                                    props.combinedPlanName.toUpperCase() === "SCALE"
                                      ? "0px 2px 12px #ff000099"
                                      : ""
                                  }
                                  py={8}
                                  px={6}
                                  width="325px"
                                  mt={6}
                                  className="each_plan"
                                  initial={{ opacity: 0, y: 10 }}
                                  whileInView={{ opacity: 1, y: 0 }}
                                  viewport={{ once: true }}
                                  transition={{ duration: 0.3, delay: 0.3 }}
                                  bg={"#000"}
                                >
                                  <Box maxW={"48px"}>
                                    <MdKeyboardDoubleArrowRight
                                      size={"24"}
                                      color="#E33535"
                                    />
                                  </Box>
                                  <Text
                                    as={"div"}
                                    textAlign={"start"}
                                    fontSize={"4xl"}
                                    color={"brand.white"}
                                    fontFamily={"heading"}
                                    fontWeight={"700"}
                                  >
                                    Scale
                                  </Text>

                                  <Flex justifyContent={"start"}>
                                    <Box>
                                        <Text
                                            as={'div'}
                                            fontSize={'2xl'}
                                            fontWeight={'500'}
                                            color={'brand.white'}
                                            fontFamily={'heading'}
                                            px={1}
                                        >
                                            {billingCycle === 3 && <Text 
                                              as={"span"}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              textDecor={"line-through"}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                              me={1}
                                            >
                                                {LEGACY_PLAN_PRICES.scale.quaterly.productTotal}
                                            </Text>}
                                            {billingCycle === 6 && <Text 
                                              as={"span"}
                                              fontSize={'lg'}
                                              fontWeight={'400'}
                                              textDecor={"line-through"}
                                              color={'brand.lightGray'}
                                              opacity={0.5}
                                              me={1}
                                            >
                                                {LEGACY_PLAN_PRICES.scale.semiAnually.productTotal}
                                            </Text>}
                                            {billingCycle === 1 && LEGACY_PLAN_PRICES.scale.monthly}
                                            {billingCycle === 3 && <Text as={"span"} color={"brand.green"}>{LEGACY_PLAN_PRICES.scale.quaterly.total}</Text>}
                                            {billingCycle === 6 && <Text as={"span"} color={"brand.green"}>{LEGACY_PLAN_PRICES.scale.semiAnually.total}</Text>}
                                            
                                            <Text
                                                as={'span'}
                                                fontSize={'lg'}
                                                fontWeight={'400'}
                                                color={'brand.lightGray'}
                                                opacity={0.5}
                                            >
                                                {billingCycle === 1 && "/month"} 
                                                  {billingCycle === 3 && " /3 mo"} 
                                                  {billingCycle === 6 && " /6 mo"} 
                                            </Text>
                                        </Text>
                                    </Box>
                                  </Flex>
                                  

                                  <Stack mt={6}>
                                    <Stack spacing={3}>
                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          500M Credits every month
                                        </Text>
                                      </Stack>

                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          400 RPC req/sec
                                        </Text>
                                      </Stack>

                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <ImCross
                                              color="#808080"
                                              size={15}
                                              opacity={0.4}
                                            />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color={"brand.midGrey"}
                                          fontWeight={"500"}
                                          opacity={0.4}
                                        >
                                          {" "}
                                          No gRPC Access
                                        </Text>
                                      </Stack>
                                      <Stack
                                        direction={"row"}
                                        pt={1}
                                        className="plan_bullet_points"
                                        mt={-1}
                                      >
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.yellow"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Accelerated gPA
                                        </Text>
                                      </Stack>
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          150 API req/sec
                                        </Text>
                                      </Stack>
                                      
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          $1.65 for each additional 1M credits
                                        </Text>
                                      </Stack>
                                      
                                      <Stack direction={"row"}>
                                        <Box>
                                          <Box pt={"2px"}>
                                            <FaCheck color="#808080" />
                                          </Box>
                                        </Box>
                                        <Text
                                          as={"div"}
                                          fontFamily={"Jost"}
                                          fontSize={{ base: "14px", md: "md" }}
                                          color="brand.midGrey"
                                          fontWeight={"500"}
                                        >
                                          {" "}
                                          Staked Connections
                                        </Text>
                                      </Stack>
                                    </Stack>
                                  </Stack>

                                  <Box
                                    textAlign={"center"}
                                    pt={0}
                                    height={"17px"}
                                  ></Box>

                                  <Stack
                                    as="div"
                                    h={{ base: "0px", md: "24px" }}
                                    w={{ base: "0px", md: "26px" }}
                                  ></Stack>

                                  <Box ps={"2px"} height={"20px"} mb={-4}>
                                    {billingCycle > 1 && (
                                      <Text fontWeight={"medium"} fontSize={"sm"} color={"brand.midGrey"} textAlign={"center"}>
                                        {billingCycle === 3 && `Effectively ${LEGACY_PLAN_PRICES.scale.quaterly.perMonth}/month`}
                                        {billingCycle === 6 && `Effectively ${LEGACY_PLAN_PRICES.scale.semiAnually.perMonth}/month`}
                                      </Text>
                                    )}
                                  </Box>

                                  {billingCycle === 1 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("SCALE", PlanIds.scale)
                                        }
                                      >
                                        Select Plan
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "SCALE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["SCALE"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.scale,
                                            "SCALE",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.scale,
                                            "SCALE",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 3 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("SCALE", PlanIds.scaleq)
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "SCALEQ" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["SCALEQ"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.scaleq,
                                            "SCALE",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.scaleq,
                                            "SCALE",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 10%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                  {billingCycle === 6 && <Stack>
                                    {props.combinedPlanName.toUpperCase() === "FREE" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectPlanAndPay("SCALE", PlanIds.scales)
                                        }
                                      >
                                        Select Plan
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    ) : props.combinedPlanName.toUpperCase() === "SCALES" ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        marginTop={4}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        bgColor={"brand.red"}
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                      >
                                        Current Plan
                                      </Button>
                                    ) : PlanWeight[props.combinedPlanName.toUpperCase()] >
                                      PlanWeight["SCALES"] ? (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.scales,
                                            "SCALE",
                                            "DOWN"
                                          )
                                        }
                                      >
                                        Downgrade
                                      </Button>
                                    ) : (
                                      <Button
                                        size={"sm"}
                                        width={"full"}
                                        height={"10"}
                                        margin={"0 auto"}
                                        variant={"outline"}
                                        borderColor={"brand.red"}
                                        borderRadius={"full"}
                                        className="each_plan_button"
                                        fontFamily={"heading"}
                                        fontWeight={"500"}
                                        mt={4}
                                        onClick={() =>
                                          selectUpdatePlan(
                                            PlanIds.scales,
                                            "SCALE",
                                            "UP"
                                          )
                                        }
                                      >
                                        Upgrade
                                        <Badge
                                            ml="1"
                                            mt={"-2px"}
                                            bg={"brand.yellowFade"}
                                            color={"brand.yellow"}
                                            textTransform={"capitalize"}
                                            fontWeight={"medium"}
                                            pt="2px"
                                            pb={"2px"}
                                        >
                                            Save 20%
                                        </Badge>
                                      </Button>
                                    )}
                                  </Stack>}
                                </Stack>
                              </Flex>
                            </Stack>
                          </Box>
                          <Flex
                            as="div"
                            pt={{ base: 2, md: 2 }}
                            flexWrap={"wrap"}
                          >
                            <Box
                              border={"2px solid"}
                              borderColor="brand.lightGray"
                              bg={"#000"}
                              px={"16px"}
                              py={"8px"}
                              me={"8px"}
                              borderRadius={"8px"}
                              mt={{ base: "6px", md: "0px" }}
                            >
                              <Box
                                as="div"
                                color="brand.midGrey"
                                fontSize={{ base: "xs", md: "md" }}
                              >
                                {" "}
                                1 API call = 100 credits
                              </Box>
                            </Box>
                            <Box
                              border={"2px solid"}
                              borderColor="brand.lightGray"
                              bg={"#000"}
                              px={"16px"}
                              py={"8px"}
                              borderRadius={"8px"}
                              me={"8px"}
                              mt={{ base: "6px", md: "0px" }}
                            >
                              <Box
                                as="div"
                                color="brand.midGrey"
                                fontSize={{ base: "xs", md: "md" }}
                              >
                                {" "}
                                1 RPC call = 1 credit
                              </Box>
                            </Box>
                            
                          </Flex>
                        </TabPanel>
                      </TabPanels>
                    </Tabs>
                  </Box>
                  {/* <Box>
                    <Flex
                      as="div"
                      pt={{ base: 2, md: 0}}
                      flexWrap={"wrap"}
                      justifyContent={{
                        sm: "space-around",
                        md: "space-between",
                      }}
                      mt={{base: 0, md: -4}}
                    >
                      <Stack
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.3, delay: 0.1 }}
                        maxW={{ base: "100%", md: "49%" }}
                      >
                        <Box
                          as="div"
                          border={"2px solid"}
                          borderColor="brand.lightGray"
                          borderRadius={"3xl"}
                          py={8}
                          px={8}
                          bg={"black"}
                          mt={6}
                        >
                          <Stack wrap={"wrap"} justifyContent={"space-between"}>
                            <Heading
                              as="h3"
                              color={"brand.white"}
                              fontWeight={"600"}
                              fontSize={"3xl"}
                            >
                              Shared gRPC Network{" "}
                            </Heading>
                          </Stack>
                          <Stack mt={2}>
                            <Text
                              color={"brand.grey"}
                              fontSize={{ base: "14px", lg: "md" }}
                              fontWeight={500}
                            >
                              No credits, no metering, only unlimited streaming.
                              Select the region closest to you and start
                              instantly at{" "}
                              <Text as={"span"} color={"brand.yellow"}>
                                $199/mo
                              </Text>
                              . Each region is powered by multiple nodes for
                              fault tolerance.
                              Reach out to us on <Text as={"a"} href={linksConfig.DISCORD_LINK} target="_blank" color={"brand.yellow"} _hover={{ color: "brand.red" }}>discord</Text> for queries.
                            </Text>
                          </Stack>
                          <Stack mt={{ base: 0, md: 6 }}>
                            <Link to="/dashboard/grpc">
                              <Box
                                size={"sm"}
                                fontSize={"sm"}
                                fontWeight={"600"}
                                fontFamily={"heading"}
                                borderRadius={"full"}
                                px={{ base: "12px", xl: "24px" }}
                                py={{ base: "6px", lg: "8px" }}
                                bg={"transparent"}
                                border="1px solid"
                                borderColor="brand.red"
                                color={"brand.white"}
                                my={"-2"}
                                _hover={{
                                  bgColor: "brand.red",
                                  color: "brand.white",
                                  textDecoration: "none",
                                }}
                                textAlign={"center"}
                                height={"10"}
                                maxW={"170px"}
                              >
                                Upgrade Plan
                              </Box>
                            </Link>
                          </Stack>
                        </Box>
                      </Stack>
                      <Stack
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.3, delay: 0.2 }}
                        maxW={{ base: "100%", md: "49%" }}
                        id="jup-swap-v6-api"
                      >
                        <Box
                          as="div"
                          border={"2px solid"}
                          borderColor="brand.lightGray"
                          borderRadius={"3xl"}
                          py={8}
                          px={8}
                          pb={6}
                          bg={"black"}
                          mt={8}
                        >
                          <Stack wrap={"wrap"} justifyContent={"space-between"}>
                            <Heading
                              as="h3"
                              color={"brand.white"}
                              fontWeight={"600"}
                              fontSize={"3xl"}
                            >
                              JUP Swap API 🔥{" "}
                            </Heading>
                          </Stack>
                          <Stack mt={2}>
                            <Text
                              color={"brand.grey"}
                              fontSize={{ base: "14px", lg: "md" }}
                              fontWeight={500}
                            >
                              Access region specific JUP Swap API. No
                              self-hosting required, start trading instantly at{" "}
                              <Text as={"span"} color={"brand.yellow"}>
                                $299/mo
                              </Text>{" "}
                              and{" "}
                              <Text as={"span"} color={"brand.yellow"}>
                                150 req/sec
                              </Text>
                              . No credit system or upper monthly limit. Reach
                              out to us on{" "}
                              <Text
                                as={"a"}
                                href="#"
                                target="_blank"
                                color={"brand.yellow"}
                                _hover={{ color: "brand.red" }}
                              >
                                dashboard support
                              </Text>{" "}
                              to get access.
                            </Text>
                          </Stack>
                          <Stack mt={{ base: 0, md: 2 }}>
                            <Button
                              as={"a"}
                              href={linksConfig.DISCORD_LINK}
                              target="_blank"
                              pt={"11px"}
                              pb={"10px"}
                              display={"block"}
                              size={"sm"}
                              // width={"28"}
                              height={"10"}
                              maxW={"170px"}
                              border={"1px solid"}
                              borderColor={"brand.red"}
                              bgColor={"#000"}
                              color={"brand.white"}
                              borderRadius={"full"}
                              textColor={"#fff"}
                              fontFamily={"heading"}
                              fontWeight={"500"}
                              _hover={{
                                bgColor: "brand.red",
                                color: "brand.white",
                                textDecoration: "none",
                              }}
                              mt={{ base: 3, md: 2, lg: 0 }}
                              textAlign={"center"}
                            >
                              Connect with us
                            </Button>
                          </Stack>
                        </Box>
                      </Stack>
                    </Flex>
                  </Box> */}
                  <Box>
                    <Flex
                      as="div"
                      pt={{ base: 2, md: 2 }}
                      flexWrap={"wrap"}
                      justifyContent={{
                        sm: "space-around",
                        md: "space-between",
                      }}
                    >
                      <Stack maxW={{ base: "100%", md: "49%" }}>
                        <Box
                          as="div"
                          border={"2px solid"}
                          borderColor="brand.lightGray"
                          borderRadius={"3xl"}
                          py={8}
                          px={8}
                          bg={"black"}
                          mt={6}
                        >
                          <Stack wrap={"wrap"} justifyContent={"space-between"}>
                            <Heading
                              as="h3"
                              color={"brand.white"}
                              fontWeight={"600"}
                              fontSize={"3xl"}
                            >
                              Enterprise{" "}
                            </Heading>
                          </Stack>
                          <Stack mt={2}>
                            <Text
                              color={"brand.grey"}
                              fontSize={{ base: "14px", lg: "md" }}
                              fontWeight={500}
                            >
                              For business with larger volume or unique business
                              models. We provide custom plans based on your
                              credit and rate limit requirements.
                              <br />
                              Reach out to us on{" "}
                              <Text
                                as={"a"}
                                color={"brand.yellow"}
                                _hover={{ color: "brand.red" }}
                              >
                                dashboard support
                              </Text>{" "}
                              for queries.
                            </Text>
                          </Stack>
                          <Stack mt={{ base: 3, md: 6 }}>
                            <PopupButton
                              url="https://calendly.com/shyft-dev/lets-talk"
                              rootElement={
                                document.getElementsByTagName("body")[0]
                              }
                              text=""
                              className={"calendly_button_common"}
                            />
                          </Stack>
                        </Box>
                      </Stack>
                      <Stack maxW={{ base: "100%", md: "49%" }}>
                        <Box
                          as="div"
                          border={"2px solid"}
                          borderColor="brand.lightGray"
                          borderRadius={"3xl"}
                          py={8}
                          px={8}
                          bg={"black"}
                          mt={6}
                        >
                          <Stack wrap={"wrap"} justifyContent={"space-between"}>
                            <Heading
                              as="h3"
                              color={"brand.white"}
                              fontWeight={"600"}
                              fontSize={"3xl"}
                            >
                              Dedicated Solana RPCs{" "}
                            </Heading>
                          </Stack>
                          <Stack mt={2}>
                            <Text
                              color={"brand.grey"}
                              fontSize={{ base: "14px", lg: "md" }}
                              fontWeight={500}
                            >
                              Boost your development with our fault-tolerant
                              dedicated nodes. Starting from{" "}
                              <Text as={"span"} color={"brand.yellow"}>
                                $1800/mo
                              </Text>
                              . We also deploy a proxy which tracks your node's
                              health and routes to our backup pool in case of
                              lag or downtimes.
                            </Text>
                          </Stack>
                          <Stack mt={{ base: 0, md: 6 }}>
                            <Button
                              as={"a"}
                              href={linksConfig.DISCORD_LINK}
                              target="_blank"
                              pt={"12px"}
                              pb={"10px"}
                              display={"block"}
                              size={"sm"}
                              // width={"28"}
                              height={"10"}
                              maxW={"170px"}
                              border={"1px solid"}
                              borderColor={"brand.red"}
                              bgColor={"#000"}
                              color={"brand.white"}
                              borderRadius={"full"}
                              textColor={"#fff"}
                              fontFamily={"heading"}
                              fontWeight={"500"}
                              _hover={{
                                bgColor: "brand.red",
                                color: "brand.white",
                                textDecoration: "none",
                              }}
                              mt={{ base: 5, md: 1, lg: 0 }}
                              textAlign={"center"}
                            >
                              Connect with us
                            </Button>
                          </Stack>
                        </Box>
                      </Stack>
                    </Flex>
                  </Box>
                </Stack>
              </Box>
              
              <Box id="compare-plans" paddingTop={"54px"}>
                <Box pb={{ base: 8, md: 12 }}>
                    <CombinedHeading
                      topHeading="Side-by-Side Plan Comparison"
                      mainHeading="Compare Plans"
                      subHeading="Compare RPC & gRPC Pricing – Choose The Plan Best Suited For Your Needs"
                      isCenter={true}
                    />
                </Box>
                <Box>
                  <Flex>
                    <Box flex={5} pe={"24px"}>
                      <Box>
                        <Stack spacing={0}>
                          <Box>
                            <Text
                              as={"div"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.white"}
                              fontFamily={"heading"}
                              px={1}
                              paddingTop={"31px"}
                              paddingBottom={"8"}
                              borderBottom={"1px solid"}
                              borderBottomColor={"brand.faintGrey"}
                            >
                              Solana RPCs
                            </Text>
                          </Box>
                          {featureList.rpc.map((value, index) => (
                            <Box
                              ps={1}
                              pe={4}
                              pt={4}
                              pb={3}
                              borderBottom={"1px solid"}
                              borderBottomColor={
                                index === featureList.length - 1
                                  ? "brand.white"
                                  : "brand.faintGrey"
                              }
                            >
                              <Flex>
                                <Text
                                  as={"div"}
                                  fontSize={"md"}
                                  fontWeight={"400"}
                                  color={"brand.midGrey"}
                                  fontFamily={"body"}
                                >
                                  {value}
                                </Text>
                                {index === 2 && (
                                  <Tooltip
                                    label="getProgramAccounts, getTokenLargetAccounts, getTokenAccountsByOwner"
                                    fontSize="xs"
                                  >
                                    <Box ps={2} marginTop={"-2px"}>
                                      <WarningIcon color={"brand.midGrey"} />
                                    </Box>
                                  </Tooltip>
                                )}
                              </Flex>
                            </Box>
                          ))}
                        </Stack>
                      </Box>
                    </Box>
                    <Box flex={13} overflowX={{ sm: "scroll", md: "hidden" }}>
                      <Flex>
                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            <Box
                              paddingTop={"2"}
                              paddingBottom={"4"}
                              borderRight={"1px solid"}
                              borderColor={"brand.faintGrey"}
                              borderBottom={"1px solid"}
                              borderBottomColor={"brand.faintGrey"}
                              borderTop={"1px solid"}
                              borderTopColor={"brand.faintGrey"}
                              borderTopLeftRadius={"2xl"}
                              borderLeft={"1px solid"}
                              borderLeftColor={"brand.faintGrey"}
                              // bg={"#000"}
                              bg={
                                props.combinedPlanName.toUpperCase() === "FREE"
                                  ? "brand.red"
                                  : "#000"
                              }
                              
                            >
                              <Text
                                as={"div"}
                                fontSize={"3xl"}
                                fontWeight={"400"}
                                color={"brand.white"}
                                fontFamily={"heading"}
                                px={1}
                              >
                                Free
                              </Text>
                              <Box
                                fontSize={"sm"}
                                color={
                                props.combinedPlanName.toUpperCase() === "FREE"
                                  ? "brand.lighterWhite"
                                  : "brand.lighterWhite"
                                }
                                mt={"-2px"}
                                fontWeight={props.combinedPlanName.toUpperCase() === "FREE"?"500":"400"}
                              >
                                $0/mo
                              </Box>
                            </Box>
                            {Object.values(FREE_DETAILS.rpc).map(
                              (value, index) => (
                                <Box flex={1}>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderBottomLeftRadius={
                                      index ===
                                      Object.values(FREE_DETAILS.rpc).length - 1
                                        ? "2xl"
                                        : "0px"
                                    }
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "FREE"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            <Box
                              paddingTop={"2"}
                              paddingBottom={"4"}
                              borderRight={"1px solid"}
                              borderColor={"brand.faintGrey"}
                              borderBottom={"1px solid"}
                              borderBottomColor={"brand.faintGrey"}
                              borderTop={"1px solid"}
                              borderTopColor={"brand.faintGrey"}
                              borderLeft={"1px solid"}
                              borderLeftColor={"brand.faintGrey"}
                              // bg={"#000"}
                              bg={
                                props.combinedPlanName.toUpperCase() === "BUILD"
                                  ? "brand.red"
                                  : "#000"
                              }
                            >
                              <Text
                                as={"div"}
                                fontSize={"3xl"}
                                fontWeight={"400"}
                                color={"brand.white"}
                                fontFamily={"heading"}
                                px={1}
                              >
                                Build
                              </Text>
                              <Box
                                fontSize={"sm"}
                                color={props.combinedPlanName.toUpperCase() === "BUILD"
                                  ? "#fff"
                                  : "brand.midGrey"
                                }
                                mt={"-2px"}
                                fontWeight={props.combinedPlanName.toUpperCase() === "BUILD"? "500": "400"}
                              >
                                $199/mo
                              </Box>
                            </Box>
                            {Object.values(BUILD_DETAILS.rpc).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "BUILD"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            <Box
                              paddingTop={"2"}
                              paddingBottom={"4"}
                              borderRight={"1px solid"}
                              borderColor={"brand.faintGrey"}
                              borderBottom={"1px solid"}
                              borderBottomColor={"brand.faintGrey"}
                              borderTop={"1px solid"}
                              borderTopColor={"brand.faintGrey"}
                              borderLeft={"1px solid"}
                              borderLeftColor={"brand.faintGrey"}
                              //bg={"#000"}
                              bg={
                                props.combinedPlanName.toUpperCase() === "GROW"
                                  ? "brand.red"
                                  : "#000"
                              }
                            >
                              <Text
                                as={"div"}
                                fontSize={"3xl"}
                                fontWeight={"400"}
                                color={"brand.white"}
                                fontFamily={"heading"}
                                px={1}
                              >
                                Grow
                              </Text>
                              <Box
                                fontSize={"sm"}
                                color={props.combinedPlanName.toUpperCase() === "GROW" ? "#fff" : "brand.midGrey"}
                                mt={"-2px"}
                                fontWeight={props.combinedPlanName.toUpperCase() === "GROW" ?"500": "400"}
                              >
                                $349/mo
                              </Box>
                            </Box>
                            {Object.values(GROW_DETAILS.rpc).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={
                                      index === featureList.length - 1
                                        ? "brand.faintGrey"
                                        : "brand.faintGrey"
                                    }
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "GROW"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            <Box
                              paddingTop={"2"}
                              paddingBottom={"4"}
                              borderRight={"1px solid"}
                              borderColor={"brand.faintGrey"}
                              borderBottom={"1px solid"}
                              borderBottomColor={"brand.faintGrey"}
                              borderTop={"1px solid"}
                              borderTopColor={"brand.faintGrey"}
                              borderTopRightRadius={"2xl"}
                              borderLeft={"1px solid"}
                              borderLeftColor={"brand.faintGrey"}
                              //bg={"#000"}
                              bg={
                                props.combinedPlanName.toUpperCase() === "ACCELERATE"
                                  ? "brand.red"
                                  : "#000"
                              }
                            >
                              <Text
                                as={"div"}
                                fontSize={"3xl"}
                                fontWeight={"400"}
                                color={"brand.white"}
                                fontFamily={"heading"}
                                px={1}
                              >
                                Accelerate
                              </Text>
                              <Box
                                fontSize={"sm"}
                                color={props.combinedPlanName.toUpperCase() === "ACCELERATE" ? "#fff" : "brand.midGrey"}
                                mt={"-2px"}
                                fontWeight={props.combinedPlanName.toUpperCase() === "ACCELERATE" ?"500": "400"}
                              >
                                $649/mo
                              </Box>
                            </Box>
                            {Object.values(ACCELERATE_DETAILS.rpc).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderRight={"1px solid"}
                                    borderRightColor={"brand.faintGrey"}
                                    borderBottomRightRadius={
                                      index ===
                                      Object.values(ACCELERATE_DETAILS.rpc)
                                        .length -
                                        1
                                        ? "2xl"
                                        : "0px"
                                    }
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "ACCELERATE"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>
                      </Flex>
                    </Box>
                  </Flex>

                  <Box
                    pt={10}
                    pb={2}
                    color={"brand.white"}
                    fontFamily={"heading"}
                    fontSize={"lg"}
                  >
                    Yellowstone gRPC
                  </Box>

                  <Flex>
                    <Box flex={5} pe={"24px"}>
                      <Box>
                        <Stack spacing={0}>
                          {featureList.grpc.map((value, index) => (
                            <Box
                              ps={1}
                              pe={4}
                              pt={4}
                              pb={3}
                              borderBottom={"1px solid"}
                              borderBottomColor={
                                index === featureList.length - 1
                                  ? "brand.white"
                                  : "brand.faintGrey"
                              }
                            >
                              <Flex>
                                <Text
                                  as={"div"}
                                  fontSize={"md"}
                                  fontWeight={"400"}
                                  color={"brand.midGrey"}
                                  fontFamily={"body"}
                                >
                                  {value}
                                </Text>
                                {index === 0 && (
                                  <Tooltip
                                    label="There is no limit on the number of IPs you can connect from. You can have 1 IP with 10 connections or 10 IPs with 1 connections each."
                                    fontSize="xs"
                                  >
                                    <Box ps={2} marginTop={"-2px"}>
                                      <WarningIcon color={"brand.midGrey"} />
                                    </Box>
                                  </Tooltip>
                                )}
                                {index === 1 && (
                                  <Tooltip
                                    label="Number of gRPC clients that can concurrently connect and stream from any number of IPs."
                                    fontSize="xs"
                                  >
                                    <Box ps={2} marginTop={"-2px"}>
                                      <WarningIcon color={"brand.midGrey"} />
                                    </Box>
                                  </Tooltip>
                                )}
                              </Flex>
                            </Box>
                          ))}
                        </Stack>
                      </Box>
                    </Box>
                    <Box flex={13} overflowX={{ sm: "scroll", md: "hidden" }}>
                      <Flex>
                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            {Object.values(FREE_DETAILS.grpc).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderBottomLeftRadius={
                                      index ===
                                      Object.values(FREE_DETAILS.grpc).length -
                                        1
                                        ? "2xl"
                                        : "0px"
                                    }
                                    borderTopLeftRadius={
                                      index === 0 ? "2xl" : "0px"
                                    }
                                    borderTop={
                                      index === 0 ? "1px solid" : "0px solid"
                                    }
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "FREE"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            {Object.values(BUILD_DETAILS.grpc).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderTop={
                                      index === 0 ? "1px solid" : "0px solid"
                                    }
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "BUILD"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            {Object.values(GROW_DETAILS.grpc).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderTop={
                                      index === 0 ? "1px solid" : "0px solid"
                                    }
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "GROW"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            {Object.values(ACCELERATE_DETAILS.grpc).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderRight={"1px solid"}
                                    borderRightColor={"brand.faintGrey"}
                                    borderBottomRightRadius={
                                      index ===
                                      Object.values(ACCELERATE_DETAILS.grpc)
                                        .length -
                                        1
                                        ? "2xl"
                                        : "0px"
                                    }
                                    borderTopRightRadius={
                                      index === 0 ? "2xl" : "0px"
                                    }
                                    borderTop={
                                      index === 0 ? "1px solid" : "0px solid"
                                    }
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "ACCELERATE"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>
                      </Flex>
                    </Box>
                  </Flex>

                  <Box
                    pt={10}
                    pb={2}
                    color={"brand.white"}
                    fontFamily={"heading"}
                    fontSize={"lg"}
                  >
                    Solana APIs
                  </Box>
                  <Flex>
                    <Box flex={5} pe={"24px"}>
                      <Box>
                        <Stack spacing={0}>
                          {featureList.api.map((value, index) => (
                            <Box>
                              <Text
                                as={"div"}
                                fontSize={"md"}
                                fontWeight={"400"}
                                color={"brand.midGrey"}
                                fontFamily={"body"}
                                ps={1}
                                pe={4}
                                pt={4}
                                pb={3}
                                borderBottom={"1px solid"}
                                borderBottomColor={
                                  index === featureList.length - 1
                                    ? "brand.white"
                                    : "brand.faintGrey"
                                }
                              >
                                {value}
                              </Text>
                            </Box>
                          ))}
                        </Stack>
                      </Box>
                    </Box>
                    <Box flex={13} overflowX={{ sm: "scroll", md: "hidden" }}>
                      <Flex>
                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            {Object.values(FREE_DETAILS.api).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderBottomLeftRadius={
                                      index ===
                                      Object.values(FREE_DETAILS.api).length - 1
                                        ? "2xl"
                                        : "0px"
                                    }
                                    borderTopLeftRadius={
                                      index === 0 ? "2xl" : "0px"
                                    }
                                    borderTop={
                                      index === 0 ? "1px solid" : "0px solid"
                                    }
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "FREE"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            {Object.values(BUILD_DETAILS.api).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderTop={
                                      index === 0 ? "1px solid" : "0px solid"
                                    }
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "BUILD"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            {Object.values(GROW_DETAILS.api).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={
                                      index === featureList.length - 1
                                        ? "brand.faintGrey"
                                        : "brand.faintGrey"
                                    }
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderTop={
                                      index === 0 ? "1px solid" : "0px solid"
                                    }
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "GROW"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>

                        <Box flex={1} textAlign={"center"}>
                          <Stack spacing={0}>
                            {Object.values(ACCELERATE_DETAILS.api).map(
                              (value, index) => (
                                <Box>
                                  <Text
                                    as={"div"}
                                    fontSize={"md"}
                                    fontWeight={"400"}
                                    color={"brand.grey"}
                                    fontFamily={"body"}
                                    ps={1}
                                    pe={4}
                                    pt={3}
                                    pb={4}
                                    borderBottom={"1px solid"}
                                    borderBottomColor={"brand.faintGrey"}
                                    borderLeft={"1px solid"}
                                    borderLeftColor={"brand.faintGrey"}
                                    borderRight={"1px solid"}
                                    borderRightColor={"brand.faintGrey"}
                                    borderBottomRightRadius={
                                      index ===
                                      Object.values(ACCELERATE_DETAILS.api)
                                        .length -
                                        1
                                        ? "2xl"
                                        : "0px"
                                    }
                                    borderTopRightRadius={
                                      index === 0 ? "2xl" : "0px"
                                    }
                                    borderTop={
                                      index === 0 ? "1px solid" : "0px solid"
                                    }
                                    borderTopColor={"brand.faintGrey"}
                                    bg={
                                      props.combinedPlanName.toUpperCase() === "ACCELERATE"
                                        ? "#000"
                                        : "transparent"
                                    }
                                  >
                                    {typeof value === "boolean" ? (
                                      value ? (
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          py={"4px"}
                                        >
                                          <FaCheck color="#E33535" />
                                        </Box>
                                      ) : (
                                        <Box>--</Box>
                                      )
                                    ) : (
                                      <Box as="span">{value}</Box>
                                    )}
                                  </Text>
                                </Box>
                              )
                            )}
                          </Stack>
                        </Box>
                      </Flex>
                    </Box>
                  </Flex>
                </Box>
              </Box>
            </Container>
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
